import { Component, OnInit, OnDestroy } from '@angular/core';
import { OktaService } from '../okta.service';
import { ActivatedRoute } from '@angular/router';
import { PublisherService } from '../../../core/services/publisher.service';
import { NgForm } from '@angular/forms';
import { AppUtilService } from '../../../core/utils/app-util.service';
import { HttpError } from '../../../shared/models/http-error';
import { OktaOperation } from '../okta-operation';
import {
  OktaOperationType,
  OktaOperationSource,
  CacheConstant,
  CacheDuration
} from '../../../core/constants/app.constant';
import { Subscription } from 'rxjs';
import { OktaRoutes } from '../../../core/constants/routes.constant';
import { OktaConstant } from '../okta.constant';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';

@Component({
  selector: 'par-unlock-account',
  templateUrl: './unlock-account.component.html',
  styleUrls: ['./unlock-account.component.scss']
})
export class UnlockAccountComponent implements OnInit, OnDestroy {
  /***************Properties***************/
  websiteName: string = this.cache.get(CacheConstant.Env_Properties).theme;
  private unlockSubscription: Subscription;
  unlock: any = {
    errorMessage: '',
    username: ''
  };
  /***************Properties***************/

  /***************Constructor***************/
  constructor(
    private cache: AppCacheService,
    private oktaService: OktaService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    PublisherService.changeBannerHeader('Unlock Account');
    this.unlockSubscription = this.route.params.subscribe(params => {
      if (params.token) {
        this.setOktaCacheOperation({ token: params.token });
        AppUtilService.router.navigate([OktaRoutes.VerifyToken]);
      }
    });
  }

  ngOnDestroy(): void {
    this.unlockSubscription.unsubscribe();
  }
  /***************Constructor***************/

  /***************Component Methods***************/

  onCancelClick() {
    AppUtilService.redirectToHome();
  }

  onUnlockAccountSubmit() {
    if (!this.unlock.username) {
      this.unlock.errorMessage = OktaConstant.Messages.IdetificationRequiredMesssage;
      return;
    }

    this.unlock.errorMessage = '';

    this.oktaService
      .sendUnlockAccountEmail(this.unlock.username)
      .subscribe((response: any) => {
        if (!response.hasError) {
          this.setOktaCacheOperation({ emailAddress: response.emailAddress });
          AppUtilService.router.navigate([OktaRoutes.EmailSent]);
        } else {
          this.unlock.errorMessage = AppUtilService.resolveErrorResponse(
            response as HttpError
          ).messageText;
        }
      });
  }

  /***************Component Methods***************/

  /***************Private Methods***************/

  private setOktaCacheOperation(data: any) {
    const unlockOperation: OktaOperation = {
      type: OktaOperationType.UnlockAccount,
      source: OktaOperationSource.UnlockAccount,
      data: data
    };
    AppUtilService.cache.set(
      CacheConstant.Okta_Operation,
      unlockOperation,
      CacheDuration.OneMinute
    );
  }

  /***************Private Methods***************/
}
